import curd from '../curd'

const BASE_PATH = '/device/category'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/DeviceCategory.js